import React from "react";

import {
  CARD_W,
  ROUND_GAP,
  VIEW_PADDING_X,
  getMatchCenterY,
} from "./bracketLayout";

const BracketConnectors = ({ rounds, width, height }) => {
  const paths = [];

  rounds.forEach((round, roundIndex) => {
    if (roundIndex >= rounds.length - 1) return;

    round.pairs.forEach((pair) => {
      const fromX =
        VIEW_PADDING_X + roundIndex * (CARD_W + ROUND_GAP) + CARD_W;
      const fromY = getMatchCenterY(roundIndex, pair.matchIndex);

      const toRoundIndex = roundIndex + 1;
      const toMatchIndex = Math.floor(pair.matchIndex / 2);

      const toX =
        VIEW_PADDING_X + toRoundIndex * (CARD_W + ROUND_GAP);
      const toY = getMatchCenterY(toRoundIndex, toMatchIndex);

      const midX = fromX + (toX - fromX) / 2;

      paths.push({
        key: `${roundIndex}-${pair.matchIndex}`,
        d: `M ${fromX} ${fromY} H ${midX} V ${toY} H ${toX}`,
        completed: !!pair.winnerId || !!pair.autoWinner,
      });
    });
  });

  return (
    <svg
      className="pointer-events-none absolute inset-0 z-0"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
    >
      {paths.map((path) => (
        <path
          key={path.key}
          d={path.d}
          fill="none"
          stroke={path.completed ? "#22c55e" : "#cbd5e1"}
          strokeWidth={path.completed ? 3 : 2}
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={path.completed ? 0.95 : 0.75}
        />
      ))}
    </svg>
  );
};

export default BracketConnectors;